export default {
  readyForReview: 'Ready For Review',
  readyForPublication: 'Ready For Publication',
};
